export const renderGlql = async (els = []) => {
  if (els.length === 0) return;
  const { default: render } = await import(/* webpackChunkName: 'glql' */ '/builds/gitlab/gitlab-ee/app/assets/javascripts/glql/index.js?vue3');
  render(els);
};
